import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DocumentsTable } from "./table";
import { R1DocumentsEdit } from "./edit";

export default function R1Documents() {
  useEffect(() => {
    setDocumentTitle("Quantilia | R1 documents");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<R1DocumentsEdit />} />
      <Route index element={<R1DocumentsTable />} />
    </Routes>
  );
}
